import { CaseContext } from './case-context.interface';

export const DEFAULT_CONTEXT_VALUE: CaseContext = {
  id: null,
  type: null,
  courtId: null,
  subscriberId: null,
  roles: [],
  uuid: '',
};
